import PropTypes from 'prop-types';

import FlashPaymentWebhookLogs from 'components/flash-payment-webhook-logs/FlashPaymentWebhookLogs';
import WebhookLogModal from 'components/flash-payment-webhook-logs/WebhookLogModal';

export default function CustomerFlashWebhookLogsTab({ customerId }) {
  return (
    <>
      <FlashPaymentWebhookLogs filterByCustomer={true} customerId={customerId} />
      <WebhookLogModal />
    </>
  );
}

CustomerFlashWebhookLogsTab.propTypes = {
  customerId: PropTypes.string.isRequired,
};
